import axios from "axios";
import { showSessionExpiredModal } from "../slices/authSlice";
import getTenantId from "../../components/Tenent";

const getStore = () => require("../store").store;

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_SUPPLIER_API_HOST}`,
  withCredentials: true,
  headers: { accept: "application/json" },
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers["x-tenant-id"] = getTenantId();
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname !== "/login") {
      getStore().dispatch(showSessionExpiredModal(window.location.pathname));
    }
    return Promise.reject(err);
  }
);

const axiosBaseQuery =
  () =>
  async ({ url, method, body, params, ...requestOpts }) => {
    try {
      const result = await axiosInstance({
        url,
        method,
        data: body,
        params,
        headers: requestOpts.headers,
      });
      return { data: result.data };
    } catch (axiosError) {
      return {
        error: {
          status: axiosError.response?.status,
          data: axiosError.response?.data || axiosError.message,
        },
      };
    }
  };

export default axiosBaseQuery();
